import DebitCardPaymentContainer from './DebitCardPaymentContainer';

export default DebitCardPaymentContainer;
